export const API_MODULE_NAME = 'pfdod';



// WEBPACK FOOTER //
// ./src/mixins/const.js